import InternalTemplate from './Internal';

export default InternalTemplate;
